module.exports = __webpack_public_path__ + "img/header-noti.99a881f2.svg";